declare var angular: ng.IAngularStatic;
import { breadcrumbsComponent } from '../../components/breadcrumbs/breadcrumbs';
import { productIconToolbarComponent } from '../../components/product-icon-toolbar/product-icon-toolbar';
import { productImageGalleryComponent } from '../../components/product-image-gallery/product-image-gallery';
import { productInfoHeaderComponent } from '../../components/product-info-header/product-info-header';
import { productInfoFooterComponent } from '../../components/product-info-footer/product-info-footer';
import { productPriceComponent } from '../../components/product-price/product-price';
import { productAttributesComponent } from '../../components/product-attributes/product-attributes';
import { productTechnicalSpecsComponent } from '../../components/product-technical-specs/product-technical-specs';
import { product_view_comments_component } from '../../components/product-view-comments/product-view-comments';
import { product_add_comment_component } from '../../components/product-add-comment/product-add-comment';
import { storeProductDetailComponent } from '../../components/store-product-detail/store-product-detail';
import { productVendorlistComponent } from '../../components/product-vendorlist/product-vendorlist';

import { cloudZoomDirective } from '../../directives/cloudzoom/cloudzoom';

import { breadcrumbsFactory } from '../../factories/breadcrumbs/breadcrumbs';
import { productFactory } from '../../factories/product/product';
import { vendorInfoFactory } from '../../factories/vendor-info/vendor-info';
import { salabelItemFactory } from '../../factories/salabel-item/salabel-item';
import { rateFactory } from '../../factories/rate/rate';
import { commentFactory } from '../../factories/comment/comment';
import { geoFactory } from '../../factories/geo/geo';

import { compareService } from '../../services/compare/compare';
import { orderService } from '../../services/order/order';
import { cartService } from '../../services/cart/cart';
import { modulePathService } from '../../services/modulePath/modulePath';
import { notifyService } from '../../services/notify/notify';
import { managementPriceFormComponent } from '../../components/management-price-form/management-price-form';
import {
  SalableItems,
  Manufacturer,
  Product
} from '../management/vendorAdmin.service';
import { LazyAutocomplete } from '../../components/lazy-autocomplete/lazy-autocomplete.component';
import { closeOnBlur_Directive } from '../management/close-on-blur.directive';

var storeProductDetailModule = angular.module('store-product-detail', []);

storeProductDetailModule.component('breadcrumbs', breadcrumbsComponent);
storeProductDetailModule.component(
  'productIconToolbar',
  productIconToolbarComponent
);
storeProductDetailModule.component(
  'productImageGallery',
  productImageGalleryComponent
);
storeProductDetailModule.component(
  'productInfoHeader',
  productInfoHeaderComponent
);
storeProductDetailModule.component(
  'productInfoFooter',
  productInfoFooterComponent
);
storeProductDetailModule.component('productPrice', productPriceComponent);
storeProductDetailModule.component(
  'productAttributes',
  productAttributesComponent
);
storeProductDetailModule.component(
  'productTechnicalSpecs',
  productTechnicalSpecsComponent
);
storeProductDetailModule.component(
  'productAddComment',
  product_add_comment_component
);
storeProductDetailModule.component(
  'productViewComments',
  product_view_comments_component
);
storeProductDetailModule.component(
  'storeProductDetail',
  storeProductDetailComponent
);
storeProductDetailModule.component(
  'productVendorlist',
  productVendorlistComponent
);
storeProductDetailModule.component(
  'managementPriceForm',
  managementPriceFormComponent
);
storeProductDetailModule.component(LazyAutocomplete.selector, LazyAutocomplete);

storeProductDetailModule.factory('$breadcrumbs', breadcrumbsFactory);
storeProductDetailModule.factory('$product', productFactory);
storeProductDetailModule.factory('$vendorInfo', vendorInfoFactory);
storeProductDetailModule.factory('$salabelItem', salabelItemFactory);
storeProductDetailModule.factory('$comment', commentFactory);
storeProductDetailModule.factory('$rate', rateFactory);
storeProductDetailModule.factory('$geo', geoFactory);
storeProductDetailModule.factory('$SalableItems', SalableItems);
storeProductDetailModule.service('$compare', compareService);
storeProductDetailModule.service('$order', orderService);
storeProductDetailModule.service('$cart', cartService);
storeProductDetailModule.service('$mPath', modulePathService);
storeProductDetailModule.service('$notify', notifyService);
storeProductDetailModule.service('$Manufacturer', Manufacturer);
storeProductDetailModule.service('$Product', Product);
storeProductDetailModule.directive('cloudzoom', cloudZoomDirective);
storeProductDetailModule.directive('closeOnBlur', closeOnBlur_Directive);



// WEBPACK FOOTER //
// ./src/store-modules/product-detail/product-detail.ts